<template>
	<v-dialog v-model="dialog" persistent no-click-animation scrollable max-width="500">
		<v-card class="rounded-lg" style="border: 1px #ccc solid" elevation="0">
			<v-card-title class="pl-4 pt-4">
				服务地区
				<v-spacer></v-spacer>
				<v-btn class="mx-0" icon @click="close()"><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-divider class="grey lighten-2" />
			<v-card-text class="px-0">
				<v-treeview v-model="selection" open-all selectable activatable transition dense hoverable item-key="areaCode" item-text="areaName" :items="items" class="tree scrollbar"> </v-treeview>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer />
				<v-btn @click="close" text> 取消 </v-btn>
				<v-btn @click="submit" text color="primary"> 确定 </v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Request from "@/commons/request";
import Message from "../../components/message";
export default {
	data() {
		return {
			items: [],
			dialog: false,
			selection: [],
			udi: "",
		};
	},
	mounted() {},
	methods: {
		opend(areaArr, areaCode, udi) {
			this.items = areaArr;
			this.dialog = true;
			this.selection = areaCode.split(",");
			this.udi = udi;
		},
		close() {
			this.open = [];
			this.active = [];
			this.dialog = false;
		},
		// 递归树形结构
		submit() {
			let data = this.selection.length <= 0 ? 0 : this.selection.join();
			Request.postForm("/view/users/area", { udi: this.udi, acs: data }).then((res) => {
				if (res.meta.success) {
					Message.toast("设置成功！", { color: "success" });
					this.$emit("ok");
				}
			});
			this.close();
		},
		// // 递归树形结构
		// handleTree(data, id, parentId) {
		//   let rootId = 0;
		//   const cloneData = JSON.parse(JSON.stringify(data));
		//   const treeData = cloneData.filter((father) => {
		//     let branchArr = cloneData.filter((child) => {
		//       return father[id] === child[parentId];
		//     });
		//     branchArr.length > 0 ? (father.children = branchArr) : "";
		//     return father[parentId] === rootId;
		//   });
		//   console.log(treeData);
		//   this.items = treeData;
		// },
	},
};
</script>
<style scoped>
.tree {
	height: 61vh;
}
</style>
